module.exports = __webpack_public_path__ + "static/main7-en-28a32d2f67c8617146d70cf75e6d4e14.png";